<template>
    <div>
        <!-- 列表 -->
        <div :class="this.filiterBg ==false?'gene-mutaion': 'gene-mutaions'">
            <div class="genneRange">
                <div class="rangeContent">
                    <span>基因范围:</span>
                    <span @click="showPopup">
                        {{tag}}
                        <i :class="this.show==false?'iconfont icon-xiasanjiao':' iconfont icon-up_small'"></i>
                    </span>
                </div>
            </div>
            <!-- 自定义图标 -->
            <van-search class="search" shape="round"  @change="onChange" :value="value"  placeholder="请输入搜索关键词" />
            <div class="gene-mutaion-list">
                <div class="genne-mutaion-head" v-for="(item,index) in titleData">
                    <span>{{item.name}}</span>
                    <span>{{item.samplenum}}</span>
                    <span>{{item.percentage}}</span>
                </div>
                <div class="cards-shaw"></div>
                <div class="genne-mutaion-content" v-for="(item,index) in tableData">
                    <span>{{item.name}}</span>
                    <span>{{item.samplenum}}</span>
                    <span>{{item.percentage}}</span>
                </div>
            </div>
        </div>
        <!-- 吸顶 -->
        <div class="sticky" @click="ceiliList">
            <i class="iconfont icon-menu"></i>
        </div>
        <div @click="loadingBtn" v-show="listShow" class="loading">
        </div>
        <van-transition name="fade-right" class="ceiling-tran" >
            <div class="ceilingBox" v-show="listShow">
                <span v-for="(item,index) in ceiliingList" @click="ceiliingListIndex(item,index)">{{item.name}}</span>
            </div>
        </van-transition>
        <!-- 底部弹出 -->
        <van-popup v-model="show" round position="bottom" style="height: auto; min-height: 30%;">
            <div class="tagBox">
                <p class="iconfont icon-close" @click="showPopon"></p>
                <div class="tagcontent">
                    <van-row class="van-row">
                        <van-col class="van-col" span="7" :class="num==index?'van-cols':'van-col'"
                            v-for="(item,index) in tagList" offset="0" @click="choiceTag(item,index)">{{item.name}}
                        </van-col>
                    </van-row>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    export default {
        props: {
            tagList: null,
            tableData: null,
            tag: String,
           
        },
        data() {
            return {
                value:'',
                num: 0,
                filiterBg: false,
                listShow:false,
                show: false,
                ceiliingList: [{ name: '点突变/插入/缺失' }, { name: '拷贝数' }, { name: '基因重排' }, { name: '胚系突变' },],
                titleData: [{ name: 'Gene', samplenum: '突变样本数', percentage: '占比' }],
            }
        },
        methods: {
             // 失去焦点触发搜索
             onChange(){
                this.$emit('onChange',this.value)
                // console.log(this.value)
            },
            //禁止滚动
            stop() {
                var mo = function (e) { e.preventDefault(); };
                document.body.style.overflow = 'hidden';
                document.addEventListener("touchmove", mo, false);//禁止页面滑动
            },
            /***取消滑动限制***/
            move() {
                var mo = function (e) { e.preventDefault(); };
                document.body.style.overflow = '';//出现滚动条
                document.removeEventListener("touchmove", mo, false);
            },
           
            showPopup() {
                this.show = true
            },
            showPopon() {
                this.show = false
            },
            ceiliList() {
                this.listShow = true;
                this.filiterBg = true;
                this.stop();
            },
            loadingBtn() {
                this.filiterBg = false;
                this.listShow = false;
                this.move();
            },
            choiceTag(item, index) {
                console.log(item, index)
                this.num = index;
                this.tag = item.name
            },
            ceiliingListIndex(item, index) {
                // this.$router.path({
                //     name: 'variationDetails',
                //     params: {
                //         index: index,
                //         item: item,
                //     }
                // })
            }
        },
    }
</script>
<style lang="less" scoped>
    .cards-shaw {
        display: inline-block;
        width: 343px;
        height: 20px;
        background: linear-gradient(360deg, rgba(52, 68, 132, 0) 0%, rgba(52, 68, 132, 0.1) 100%);
    }

    .gene-mutaion {
        width: 343px;
        height: auto;
        background: #FFFFFF;
        border-radius: 10px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .gene-mutaions {
        filter: blur(10px);
        width: 343px;
        height: auto;
        background: #FFFFFF;
        border-radius: 10px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .gene-mutaion-list {
        padding-bottom: 16px;
    }

    .genne-mutaion-head {
        height: 48px;
        background: #FFFFFF;
        padding-left: 24px;
        padding-right: 24px;
    }

    .genne-mutaion-head>span {
        float: left;
        height: 48px;
        line-height: 48px;
        font-size: 15PX;
        font-family: @family;
        font-weight: 500;
        color: #9095A7;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .genne-mutaion-head>span:nth-of-type(1) {
        width: 50%;
    }

    .genne-mutaion-head>span:nth-of-type(2) {
        width: 30%;
    }

    .genne-mutaion-head>span:nth-of-type(3) {
        width: 20%;
    }

    .genne-mutaion-content {
        height: 48px;
        background: #FFFFFF;
        padding-left: 24px;
        padding-right: 24px;
    }

    .genne-mutaion-content>span {
        float: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 48px;
    }

    .genne-mutaion-content>span:nth-of-type(1) {
        float: left;
        font-size: 15PX;
        font-family: @family;
        font-weight: 500;
        color: #4B84FF;
        width: 50%;
    }

    .genne-mutaion-content>span:nth-of-type(2) {
        font-size: 15PX;
        font-family: @family;
        font-weight: 400;
        color: #2F354D;
        width: 30%;
    }

    .genne-mutaion-content>span:nth-of-type(3) {
        font-size: 15PX;
        font-family: @family;
        font-weight: 400;
        color: #2F354D;
        width: 20%;
    }

    .mutaion-tab-box {
        margin-top: 10px;
        padding-left: 24px;
        padding-right: 24px;
        margin-bottom: 14px;
    }

    .mutaion-tab {

        padding-left: 16px;
        height: 36px;
        background: #EEF4FF;
        border-radius: 6px;
    }

    .mutaion-tab>span:nth-of-type(1) {
        font-size: 12px;
        font-family: @family;
        font-weight: 400;
        color: #4B84FF;
        line-height: 36px;
    }

    .mutaion-tab>span:nth-of-type(2) {
        font-size: 12px;
        font-family: @family;
        font-weight: 400;
        color: #4B84FF;
        line-height: 36px;
        float: right;
        margin-right: 13px;
    }

    /* border-radius: 20px;
border: 1px solid #E3E5E8; */
    .search {
        padding: 16px 24px 10px 24px;

        /deep/.van-search__content {
            background: #FFFFFF;
            border-radius: 20px;
            margin: 0;
            height: 32px;
            line-height: 32px;
            border: 1px solid #E3E5E8;

            .van-field__left-icon .van-icon,
            .van-field__right-icon .van-icon {
                color: #a4a9bf;
            }

            .van-field__control {
                font-size: 12px;
                font-family: @family;
                font-weight: 400;
                color: #a4a9bf;
            }
        }

    }

    .genneRange {
        padding: 20px 0px 0px 24px;
    }

    .rangeContent>span:nth-of-type(1) {
        font-size: 13px;
        font-family: @family;
        font-weight: 500;
        color: #2F354D;
        line-height: 18PX;
    }

    .rangeContent>span:nth-of-type(2) {
        font-size: 13px;
        font-family: @family;
        font-weight: 500;
        color: #4B84FF;
        line-height: 18PX;
    }

    .sticky {
        position: fixed;
        bottom: 64px;
        right: 16px;
        width: 40px;
        height: 40px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(52, 68, 132, 0.15);
        border-radius: 10px;
        border: 1px solid #F3F5F8;
        display: flex;
        justify-content: center;
    }

    .icon-menu {
        font-size: 14px;
        color: #2F354D;
        line-height: 40px;
        text-align: center;
    }

    .icon-xiasanjiao {
        font-size: 9px;
        color: #4B84FF;
    }

    .icon-up_small {
        font-size: 9px;
        color: #4B84FF;
    }

    .tagBox {
        padding: 0px 24px;
    }

    .tagcontent {
        clear: right;
    }

    .van-row>.van-col:nth-child(3n-1) {
        margin-left: 20px;
        margin-right: 20px;
    }

    .van-col {
        background: #F8F9FB;
        border-radius: 6px;
        font-size: 12px;
        font-family: @family;
        line-height: 36px;
        font-weight: 400;
        color: #2F354D;
        padding-left: 0;
        padding-right: 0;
        margin-bottom: 10px;
        text-align: center;
        height: 36px;
    }

    .van-cols {
        font-size: 12px;
        font-family: @family;
        line-height: 36px;
        font-weight: 400;
        color: #2F354D;
        padding-left: 0;
        padding-right: 0;
        margin-bottom: 10px;
        text-align: center;
        height: 36px;
        background: #EEF4FF;
        border-radius: 6px;
        color: #4B84FF;
        border: 1px solid rgba(75, 132, 255, 0.5);
    }

    .icon-close {
        font-size: 12px;
        color: #2F354D;
        margin-top: 10px;
        margin-bottom: 10px;
        float: right;
    }

    .ceiling-tran {
        position: fixed;
        bottom: 64px;
        right: 16px;
    }

    .ceilingBox {
        /* display: none; */
    }

    .ceilingBox>span {
        padding-left: 24px;
        padding-right: 24px;
        height: 50px;
        display: block;
        width: 230px;
        margin-top: 4px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(52, 68, 132, 0.15);
        border-radius: 10px;
        border: 1px solid #F3F5F8;
        font-size: 15PX;
        font-family: @family;
        font-weight: 400;
        color: #2F354D;
        line-height: 50px;
        z-index: 20;
    }

    .loading {
        width: 100%;
        height: 100%;
        background: #2F354D;
        opacity: 0.2;
        position: fixed;
        top: 0;
    }

    /deep/.van-overlay {
        background: rgba(47, 53, 77, 0.2);
    }


</style>